// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface PrivateCloudsGetVcfLicenseOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface PrivateCloudsListAdminCredentialsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface PrivateCloudsRotateNsxtPasswordOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface PrivateCloudsRotateVcenterPasswordOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface PrivateCloudsDeleteOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface PrivateCloudsUpdateOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface PrivateCloudsCreateOrUpdateOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface PrivateCloudsGetOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface PrivateCloudsListInSubscriptionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface PrivateCloudsListOptionalParams extends OperationOptions {}
